import PropTypes from 'prop-types';
import React from 'react';

import Box from '@mui/material/Box';

import styles from './DotProgress.module.css';

// TODO: make it an MUI style to reflect the colors
function GenericDotProgress() {
  return (
    <Box sx={{ width: '125px', display: 'inline-block' }}>
      <span className={`${styles.loader}`} data-testid="dot-animation"></span>
    </Box>

  );
}

export default GenericDotProgress;
